import CroustilleElement from '../lib/CroustilleElement'
import Flickity from 'flickity-fade'

class SliderProducts extends CroustilleElement {
  constructor() {
    super('slider-products')
  }

  get container() {
    return document.querySelector(this.childSelector('container'))
  }

  load() {
    if (Flickity.data(this.container)) {
      this.slider = Flickity.data(this.container)
    } else {
      this.timeout = setTimeout(() => {
        this.slider = new Flickity(this.container, {
          pageDots: false,
          cellSelector: this.childSelector('slide'),
          freeScroll: true,
          contain: true,
          fade: true,
          adaptiveHeight: true,
          autoPlay: 5000,
          prevNextButtons: false,
          draggable: false,
          pauseAutoPlayOnHover: false
        })
        // console.log('turbolinks:load', this.slider)
      }, 20)
    }
  }

  init() {
    this.load = this.load.bind(this)
    document.addEventListener('turbolinks:load', this.load)

    // document.addEventListener('turbolinks:before-cache', () => {
    //   this.slider && this.slider.destroy()
    //   delete this.slider
    // })
  }

  destroy() {
    // document.removeEventListener('turbolinks:load', this.load)
    // clearTimeout(this.timeout)
    this.slider && this.slider.destroy()
    delete this.slider
  }
}

export default SliderProducts
